/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Chat_TitleInputs */

const en_meta_chat_title = /** @type {(inputs: Meta_Chat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI systems for your business — ask our assistant | Lindevo`)
};

const lv_meta_chat_title = /** @type {(inputs: Meta_Chat_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI sistēmas Jūsu uzņēmumam — jautājiet asistentam | Lindevo`)
};

/**
* | output |
* | --- |
* | "AI systems for your business — ask our assistant \| Lindevo" |
*
* @param {Meta_Chat_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_chat_title = /** @type {((inputs?: Meta_Chat_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Chat_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_chat_title(inputs)
	return en_meta_chat_title(inputs)
});